export default "__VITE_ASSET__DVN0rz0t__"